<template>
  <SavitzkyGolay
    v-if="selectedvalue==='Savitzky-Golay'"
    :sectionconfig="sectionconfig"
  />
  <LPF
    v-else-if="selectedvalue==='LPF'"
    :sectionconfig="sectionconfig"
  />
  <HPF
    v-else-if="selectedvalue==='HPF'"
    :sectionconfig="sectionconfig"
  />
  <BPF
    v-else-if="selectedvalue==='BPF'"
    :sectionconfig="sectionconfig"
  />
  <BSF
    v-else-if="selectedvalue==='BSF'"
    :sectionconfig="sectionconfig"
  />
  <MedianFilter
    v-else-if="selectedvalue==='Median filter'"
    :sectionconfig="sectionconfig"
  />
  <MedianAverage
    v-else-if="selectedvalue==='Moving average'"
    :sectionconfig="sectionconfig"
  />
  <AxisRange
    v-else-if="selectedvalue==='Crop'"
    :sectionconfig="sectionconfig"
  />
  <Baseline
    v-else-if="selectedvalue==='Baseline'"
    :sectionconfig="sectionconfig"
  />
  <Extrapolate
    v-else-if="selectedvalue==='Extrapolate'"
    :sectionconfig="sectionconfig"
  />
  <OffsetX
    v-else-if="selectedvalue==='Offset x'"
    :sectionconfig="sectionconfig"
  />
  <OffsetY
    v-else-if="selectedvalue==='Offset y'"
    :sectionconfig="sectionconfig"
  />
</template>

<script>
import SavitzkyGolay from './SavitzkyGolay'
import LPF from './LPF'
import HPF from './HPF'
import BPF from './BPF'
import BSF from './BSF'
import MedianFilter from './MedianFilter'
import MedianAverage from './MedianAverage'
import AxisRange from './AxisRange'
import Baseline from './Baseline'
import OffsetX from './OffsetX'
import OffsetY from './OffsetY'
import Extrapolate from './Extrapolate'

export default {
  name: 'SelectedPreProc',
  components:{
    SavitzkyGolay,
    LPF,
    HPF,
    BPF,
    BSF,
    MedianFilter,
    MedianAverage,
    AxisRange,
    Baseline,
		OffsetX,
		OffsetY,
		Extrapolate,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    },
    selectedvalue:{
      type:String,
      required:true
    }
  }
}
</script>

<style>

</style>
